// TODO: Remove this once we no longer receive error log from users
export const DESKTOP_APP_VERSION_TO_FORCE_UPDATE = '2.13.1'
